module.exports = __webpack_public_path__ + "img/ruler.be5030ca.webp";